import React from 'react';
import useAuth from '../../hooks/useAuth';

const ProfileDD = () => {
  const { getUser } = useAuth();
  const profileObj = getUser()?.profileObj;
  const name = profileObj?.name ?? '';
  const email = profileObj?.email ?? '';
  const imageUrl = profileObj?.imageUrl ?? '';
  return (
    <div>
      <div className="d-flex gap-3 p-3 border-bottom pt-2 align-items-center">
        <img src={imageUrl} alt="user" className="rounded-circle" width="60" />
        <span>
          <h6 className="mb-0">{name}</h6>
          <small>{email}</small>
        </span>
      </div>
    </div>
  );
};

export default ProfileDD;
